import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { SharedFilterComponent } from './shared-filter/shared-filter.component';
import { FilterPanelComponent } from './shared-filter/filter-panel.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PopoverModule.forRoot(),
    BsDatepickerModule.forRoot()
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedFilterComponent,
    FilterPanelComponent,
    PopoverModule,
    BsDatepickerModule
  ],
  declarations: [
    SharedFilterComponent,
    FilterPanelComponent
  ]
})
export class SharedModule { }
